import React, { useEffect, useState } from 'react';
import { useColorSettings } from '@/contexts/ColorSettingsContext';

export function ColorBadge({ color }) {
  const { colorSettings, loading } = useColorSettings();
  const [localColorData, setLocalColorData] = useState(null);

  useEffect(() => {
    if (!loading && colorSettings) {
      const colorData = colorSettings[color] || { hex: '#d1d5db', description: color };
      setLocalColorData(colorData);
    }
  }, [color, colorSettings, loading]);

  // Si no tenemos datos locales aún, mostrar un estado de carga
  if (!localColorData) {
    return (
      <div className="flex flex-col items-center">
        <div className="w-6 h-6 rounded-full border border-gray-300 bg-gray-100 animate-pulse" />
        <span className="text-xs mt-1">{color}</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <div 
        className="w-6 h-6 rounded-full border border-gray-300" 
        style={{ backgroundColor: localColorData.hex }}
        title={localColorData.description || color}
      />
      <span className="text-xs mt-1">{localColorData.description || color}</span>
    </div>
  );
} 
